import { render, staticRenderFns } from "./FMVSFootnote.vue?vue&type=template&id=440c2adc"
import script from "./FMVSFootnote.vue?vue&type=script&lang=js"
export * from "./FMVSFootnote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports